module.exports = __webpack_public_path__ + "static/mfg-brokerage-1-min.f63a7ba5.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/brokerage/mfg-brokerage-1-min.png
// module id = 490
// module chunks = 70392746020482